import { excludeUrls } from "src/constants/constants";

export const API_CONFIG = {
  excludeUrls: [
    "translation.googleapis.com",
    "meity-auth.ulcacontrib.org",
    "dhruva-api.bhashini.gov.in",
    "https://apigw.bmitpo.com/api/v1/stall?",
  ],
  encryptedApis: [
    "user/core/api/admin/v1/login",
    "user/core/api/admin/v1/update-password",
  ],
};
